import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { GetProductAssetDeleteModel, GetProductAssetModel, GetProductAssetSequence, GetProductAssetSequenceModel, ProductAssetsResponseModel, UpdateSequenceImageModel } from 'src/app/models/product/productAssets.modal';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { ProductService } from 'src/app/services/product.service';
import { UploadProductImageComponent } from '../upload-product-image/upload-product-image.component';

@Component({
  selector: 'app-product-assets-listing',
  templateUrl: './product-assets-listing.component.html',
  styleUrls: ['./product-assets-listing.component.css']
})

export class ProductAssetsListingComponent implements OnInit {
  @Input('productId') ProductId: number;
  @Input('fileType') FileType: string;
  @Input('fileChooseType') fileChooseType: string;

  Loader: boolean = false; 
  productAssetsFullList: GetProductAssetModel = new GetProductAssetModel();
  productList: ProductAssetsResponseModel = new ProductAssetsResponseModel();
  productAssetsDeleteModel: GetProductAssetDeleteModel = new GetProductAssetDeleteModel();
  ProductAssetIds: string[] = [];
  thumbnailLoader: boolean = false;
  updateSequenceModel: GetProductAssetSequenceModel = new GetProductAssetSequenceModel();
  getProductAssetSequenceModel: GetProductAssetSequence = new GetProductAssetSequence();
  assetid: any;
  sequenceid: number;
  productAssetSequence = new Array<any>();

  constructor(private localstorage: LocalstorageService,
    private _productService: ProductService,
    private alertify: AlertifyService,
    private router: ActivatedRoute, config: NgbModalConfig,
    private modalService: NgbModal, private route: Router) {
  }

  ngOnInit() {
    this.productAssetsFullList.ProductId = this.ProductId;
    this.productAssetsFullList.FileType = this.FileType.toString();
    this.productListing();
    this.FileType == this.fileChooseType;
  }

  productListing() {
    this.Loader = true;
    this.productAssetsFullList = new GetProductAssetModel();
    this.productAssetsFullList.ProductId = this.ProductId;
    this.productAssetsFullList.FileType = this.FileType.toString();
    this._productService.productAssetsListing(this.productAssetsFullList)
      .subscribe(response => {
        this.Loader = false;
        var productlisting = JSON.parse(response._body);
        if (productlisting.isSuccess) {
          this.productAssetsFullList = productlisting.responseData;
          this.productList.ProductAssetsList = productlisting.responseData;
        } (err) => {
          this.Loader = false;
        }
      });
  }

  productDelete() {
    this.Loader = true;
    this.productAssetsDeleteModel.ProductAssetIds = this.ProductAssetIds.toString();
    this._productService.productListingDelete(this.productAssetsDeleteModel)
      .subscribe((res) => {
        this.ProductAssetIds=[];
        switch (this.FileType.toString()) {
          case '2':
            document.getElementById('deletes2').classList.remove('deletelist');
            break;
          default:
            document.getElementById('deletes').classList.remove('deletelist');
            break;
        }
        this.Loader = false;
        this.productListing();
      });
  }
  setProductId(items, event) {
    let caseClasses: void;
    let itemsPushPop = event.currentTarget.checked ? this.ProductAssetIds.push(items.assetId) : this.ProductAssetIds.filter((res) => {
      let result = res == items.assetId ? this.ProductAssetIds.splice(this.ProductAssetIds.indexOf(res), 1) : "";
    })
    switch (this.FileType.toString()) {
      case '2':
        caseClasses = this.ProductAssetIds.length > 0 ? document.getElementById('deletes2').classList.add('deletelist') : document.getElementById('deletes2').classList.remove('deletelist');
        break;
      default:
        caseClasses = this.ProductAssetIds.length > 0 ? document.getElementById('deletes').classList.add('deletelist') : document.getElementById('deletes').classList.remove('deletelist');
        break;
    }
  }
  manageProductAssets() {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "xl";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._productService.passFileType(this.FileType.toString());
    this._productService.passProductId(this.ProductId);
    let modalRef = this.modalService.open(UploadProductImageComponent, modalConfig);
    modalRef.result.then(() => {
    }, (reason) => {
      this.productListing();
    });
  }

  selectDefaultThumbnail(item) {
    this.productAssetsFullList = new GetProductAssetModel();
    this.productAssetsFullList.ProductId = this.ProductId;
    this.productAssetsFullList.AssetId = item.assetId;
    this.thumbnailLoader = true;
    this._productService.productAssetsThumbnail(this.productAssetsFullList)
      .subscribe(response => {
        this.thumbnailLoader = false;
        var productThumbnail = JSON.parse(response._body);
        if (productThumbnail.isSuccess) {
          this.productListing();
          this.alertify.success(productThumbnail.responseMessage);
        } (err) => {
          this.thumbnailLoader = false;
        }
      })
  }

  dragDrop(item) {
    var cols = document.querySelectorAll('#columns .column');
    [].forEach.call(cols, addDnDHandlers);
    let imageRows = document.querySelectorAll('.assetsimageList');
    this.updateSequenceModel.ProductId = this.ProductId;
    var sequenceArray = [];
    imageRows.forEach(function (element, index) {
      var assestID = element.getAttribute('data-assetid');
      sequenceArray.push({ 'AssestId': +assestID, 'SequenceId': index + 1 });
    })
    this.updateSequenceModel.AssestSequences = sequenceArray;
    this._productService.productAssetsBySequenceListing(this.updateSequenceModel)
      .subscribe(response => {
        this.Loader = false;
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.productListing();
          this.alertify.success(responseBody.responseMessage);
        } else {
          this.alertify.error(responseBody.responseMessage);
        }
      })
  }

  dragStartFunc() {
    var cols = document.querySelectorAll('#columns .column');
    [].forEach.call(cols, startDrag);
  }
}

var dragSrcEl = null;

function startDrag(elem) {
  elem.addEventListener('dragstart', handleDragStart, false);
  elem.addEventListener('dragover', handleDragOver, false);
  elem.addEventListener('dragleave', handleDragLeave, false);
  elem.addEventListener('drop', handleDrop, false);
  elem.addEventListener('dragend', handleDragEnd, false);
}

function handleDragStart(e) {
  dragSrcEl = this;
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('text/html', this.outerHTML);    
  var img = this.getElementsByTagName("img")[0];  
  img  && img.classList.add("dragImage"); 
  var video = this.getElementsByTagName("video")[0];  
  video && video.classList.add("dragImage");  
  e.dataTransfer.setDragImage(img, 0, 0);
}

function handleDragOver(e) {
  if (e.preventDefault) {
    e.preventDefault();
  }
  this.classList.add('over');
  e.dataTransfer.dropEffect = 'move';
  return false;
}

function handleDragLeave(e) {
  this.classList.remove('over');
}

function handleDrop(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }

  if (dragSrcEl != this) {
    var thisSequenceId = this.getAttribute('data-sequence');
    var dragSequenceId = dragSrcEl.getAttribute('data-sequence');
    this.parentNode.removeChild(dragSrcEl);
    var dropHTML = e.dataTransfer.getData('text/html');
    if (thisSequenceId < dragSequenceId) {
      this.insertAdjacentHTML('beforebegin', dropHTML);
    } else if (thisSequenceId > dragSequenceId) {
      this.insertAdjacentHTML('afterend', dropHTML);
    }
    var dropElem = this.previousSibling;
    addDnDHandlers(dropElem);
  }
  this.classList.remove('over');
  return false;
}

function handleDragEnd(e) {
  this.classList.remove('over');
}

function drop(ev) {
  ev.preventDefault();
  var data = ev.dataTransfer.getData("text");
  ev.target.appendChild(document.getElementById(data));
}

function allowDrop(ev) {
  ev.preventDefault();
}


function addDnDHandlers(elem) {
  elem.addEventListener('dragstart', handleDragStart, false);
  elem.addEventListener('dragover', handleDragOver, false);
  elem.addEventListener('dragleave', handleDragLeave, false);
  elem.addEventListener('drop', handleDrop, false);
  elem.addEventListener('dragend', handleDragEnd, false);
}